<template lang="pug">
div
  b-button.float-right(type='button', disabled, variant='danger' v-if='loading')
    i.fa.fa-refresh.fa-spin
    | &nbsp;Loading
  b-button.float-right(style='color: white', type='button', variant='link' @click='showModalXlsx = true', v-else-if='(data == "total")')
    | Date Selection
  b-button.float-right(type='button', variant='outline-primary', @click='showModalXlsx = true', v-else)
    | Date Selection
  b-button.float-right.mr-2(type='button', variant='success', v-if='refreshNeeded && (data == "customer" || data == "crm")', @click='refresh')
    | Data updated, please refresh
  b-modal(v-model='showModalXlsx', title='Date Selection', @shown='clearError', lazy)
    b-btn-group.w-100
      b-button.btn-block(type='button',variant='outline-primary', @click='setWeek()')
          | &nbsp;Last 7 days
      b-button.btn-block(type='button',variant='outline-primary', @click='setMonth()')
          | &nbsp;Last 30 days
    br
    br
    h4.card-title.mb-0(style='color: red;', v-if='errorDate')
      | &nbsp;Invalid input date
    br(v-if='errorDate')
    b-row
      b-col(sm='3')
        h6.card-title.mb-0
          | Start:&nbsp;
      b-col(sm='9')
        b-form-input(type='date', size='sm', id='startDate', min="2018-03-22")
    br
    b-row
      b-col(sm='3')
        h6.card-title.mb-0
          | End:&nbsp;
      b-col(sm='9')
        b-form-input(type='date', size='sm', id='endDate', min="2018-03-22")
    br
    b-form-checkbox(id='smalltalk', v-if='data == "intent"', v-model='includesmalltalk', value='true', unchecked-value='false')
      |Include Small Talk
    div(slot='modal-footer')
      b-button.float-right.ml-1(type='button', variant='outline-primary', @click='showModalXlsx = false; errorDate = false')
        | Cancel
      b-button.float-right.ml-1(@click='drawGraphAsDate', variant='primary')
        | Show Graph

</template>
<script>
// import { downloadReport, exportReportAnalytic } from '@/api'
// import { ecp, ecrmp, eip, etp } from '@/jsonToXlsx'
import { db } from '@/firebase'

const anaRef = db.ref('analytics')
export default {
  name: 'app-dateselectionpie',
  data() {
    return {
      includesmalltalk: false,
      showModalXlsx: false,
      errorDate: false,
    }
  },
  props: {
    userAccessLevel: String,
    data: String,
    bot: String,
    loading: false,
  },
  computed: {
    bot: function() {
      return this.botProp || this.$store.state.bot
    },
    refreshNeeded: function() {
      return this.$store.getters.getRefreshNeeded
    },
  },
  methods: {
    drawGraphAsDate: function() {
      const that = this
      var initialise = true
      let userArrayTop9 = []
      let keyArrayTop9 = []
      let summedTopics = {}
      var keyArray = []
      var interationsArray = []
      var userArray = []
      var closemodal = false
      var startDate = document.getElementById('startDate').value
      var endDate = document.getElementById('endDate').value
      var sDate = this.formatDateSpace(new Date(startDate))
      var eDate = this.formatDateSpace(new Date(endDate))
      var singDate = new Date(startDate)
      var eingDate = new Date(endDate)
      var dayDifference = ((eingDate - singDate) / (24 * 60 * 60 * 1000))
      if (!document.getElementById('startDate').value || !document.getElementById('endDate').value) {
        that.errorDate = true
      } else if (startDate > endDate) {
        that.errorDate = true
      } else if (dayDifference > 31) {
        that.errorDate = true
      } else {
        closemodal = true
        let startToCount = false
        anaRef.child('daily').once('value', (snapshot) => {
          Object.entries(snapshot.val()).forEach(
            function([key, val]) {
              if (key === sDate) {
                startToCount = true
              }
              if (startToCount === true) {
                // sum up interactions & users of each of the topics over a few days into a single object
                const { topics } = val
                Object.entries(topics).forEach(([intentName, intentData]) => {
                  // if topic does not exist in summedTopics yet, initialise it with a 0
                  if (initialise == true) {
                    summedTopics['SmallTalks'] = {
                      users: 0,
                      interactions: 0,
                    }
                    initialise = false
                  }
                  if (!summedTopics[intentName]) {
                    summedTopics[intentName] = {
                      users: 0,
                      interactions: 0,
                    }
                  }
                  if (intentName.indexOf('SmallTalk') != -1) {
                    summedTopics['SmallTalks'].users += intentData.users || 0
                    summedTopics['SmallTalks'].interactions += intentData.interactions || 0
                  } else {
                    // add the interactions & interactions count to it
                    summedTopics[intentName].users += intentData.users || 0
                    summedTopics[intentName].interactions += intentData.interactions || 0
                    // (can extract summedTopics[intentName] as a var also)
                  }
                })
              }
              if (key === eDate) {
                startToCount = false
              }
            }
          )
          Object.entries(summedTopics).forEach(([intentName, intentData]) => {
            keyArray.push(intentName)
            intentData.interactions = intentData.interactions || 0
            interationsArray.push(intentData.interactions)
            intentData.users = intentData.users || 0
            userArray.push(intentData.users)
          })
          // pie user
          var keysSorted = []
          for (var i = 0; i < userArray.length; i++) {
            keysSorted.push(i) // add index to output array
            if (keysSorted.length > 10) {
              keysSorted.sort(function(a, b) { return userArray[b] - userArray[a] }) // descending sort the output array
              keysSorted.pop() // remove the last index (index of smallest element in output array)
            }
          }
          let matchExist = false
          for (let i = 0; i < 9; i += 1) {
            userArrayTop9.push(userArray[keysSorted[i]])
            keyArrayTop9.push(keyArray[keysSorted[i]])
          }
          userArrayTop9.push(0)
          keyArrayTop9.push('Others')
          for (let i = 11; i < userArray.length; i += 1) {
            for (let j = 0; j < keysSorted.length; j++) {
              if (i == keysSorted[j]) {
                matchExist = true
              }
            }
            if (matchExist == false) {
              userArrayTop9[9] += userArray[i]
            } else {
              matchExist = false
            }
          }
          // pie interaction
          var keysSortedInteraction = []
          for (i = 0; i < interationsArray.length; i++) {
            keysSortedInteraction.push(i) // add index to output array
            if (keysSortedInteraction.length > 10) {
              keysSortedInteraction.sort(function(a, b) { return interationsArray[b] - interationsArray[a] }) // descending sort the output array
              keysSortedInteraction.pop() // remove the last index (index of smallest element in output array)
            }
          }
          let interationsArrayTop9 = []
          let keyInteractionArrayTop9 = []
          matchExist = false
          for (let i = 0; i < 9; i += 1) {
            interationsArrayTop9.push(interationsArray[keysSortedInteraction[i]])
            keyInteractionArrayTop9.push(keyArray[keysSortedInteraction[i]])
          }
          interationsArrayTop9.push(0)
          keyInteractionArrayTop9.push('Others')
          for (let i = 11; i < interationsArray.length; i += 1) {
            for (let j = 0; j < keysSortedInteraction.length; j++) {
              if (i == keysSortedInteraction[j]) {
                matchExist = true
              }
            }
            if (matchExist == false) {
              interationsArrayTop9[9] += interationsArray[i]
            } else {
              matchExist = false
            }
          }
          var graphPieData = {
            graphPieLabels: keyArrayTop9,
            graphPieInteractionLabels: keyInteractionArrayTop9,
            userPieData: userArrayTop9,
            interactionPieData: interationsArrayTop9,
            timestamp: new Date(),
          }
          sDate = this.formatDate(new Date(startDate))
          eDate = this.formatDate(new Date(endDate))
          var startEndDate = {
            startingDate: sDate,
            endingDate: eDate,
          }
          var graphStatus = 'selectionDays'
          that.$store.dispatch('setGraphStatus', graphStatus)
          this.$store.dispatch('setGraphPieData', graphPieData)
          this.$store.dispatch('setStartEndDate', startEndDate)
          if (closemodal == true) {
            this.showModalXlsx = false
          }
        })
      }
    },
    testing: function() {
      var d = new Date(document.getElementById('startDate').value)
      d.setHours(d.getHours() - 8)
      // d.setHours(d.getHours() - 8)
      console.log(d)
    },
    setToday: function() {
      document.getElementById('startDate').value = this.formatDate(new Date())
      document.getElementById('endDate').value = this.formatDate(new Date())
    },
    setWeek: function() {
      document.getElementById('endDate').value = this.formatDate(new Date())
      var d = new Date()
      d.setDate(d.getDate() - 7)
      document.getElementById('startDate').value = this.formatDate(d)
    },
    setMonth: function() {
      document.getElementById('endDate').value = this.formatDate(new Date())
      var minimumDate = new Date('March 22, 2018')
      var d = new Date()
      d.setDate(d.getDate() - 30)
      if (d <= minimumDate) {
        d = minimumDate
      }
      document.getElementById('startDate').value = this.formatDate(d)
    },
    clearError: function() {
      this.errorDate = false
    },
    formatDate: function(date) {
      var d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('-')
    },
    formatDateSpace: function(date) {
      var d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('')
    },
    refresh: function() {
      this.$store.dispatch('setRefresh', true)
      this.$store.dispatch('setRefreshNeeded', false)
    },
  },
  beforeDestroy: function() {
    this.$store.dispatch('setRefreshNeeded', false)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/DateSelectionPie.vue?2acd3c1f